export { NetworkSliderComponent } from "./network-slider.component";


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/modules/+home/network-slider/index.ts